import { RouteConfig } from "vue-router";
import { RouteName } from "@/router/types";
import Login from "@/components/auth/Login.vue";
import PlayerBase from "@/components/player/components/PlayerBase.vue";
import Home from "@/components/homePage/components/Home.vue";
import ChannelsPage from "@/components/channelsPage/components/ChannelsPage.vue";
import BuffetPage from "@/components/buffet/BuffetPage.vue";
import Settings from "@/components/settings/components/Settings.vue";
import ChannelSortAndLock from "@/components/settings/components/channelsortAndLock/ChannelSortAndLock.vue";
import SettingsOptions from "@/components/settings/components/settingsPage/SettingsOptions.vue";
import UserEditForm from "@/components/settings/components/Profile/UserEditForm.vue";
import VoDPage from "@/components/VoD/component/VoDPage.vue";

export const routes: Array<RouteConfig> = [
  {
    path: "/",
    meta: { authRequired: false },
    redirect: { name: RouteName.Login }
  },
  {
    path: "/login",
    name: RouteName.Login,
    meta: { authRequired: false },
    component: Login
  },
  {
    path: "/player",
    name: RouteName.Player,
    meta: { requiresAuth: true },
    component: PlayerBase
  },
  {
    path: "/home",
    name: RouteName.Home,
    meta: { requiresAuth: true },
    component: Home
  },
  {
    path: "/channels",
    name: RouteName.Channels,
    meta: { requiresAuth: true },
    component: ChannelsPage
  },
  {
    path: "/buffet",
    name: RouteName.Buffet,
    meta: { requiresAuth: true },
    component: BuffetPage
  },
  {
    path: "/vod",
    name: RouteName.VoD,
    meta: { requiresAuth: true },
    component: VoDPage
  },
  {
    path: "/settings",
    meta: { requiresAuth: true },
    component: Settings,
    children: [
      {
        path: "",
        name: RouteName.Settings,
        meta: { requiresAuth: true },
        component: SettingsOptions
      },
      {
        path: "channel-sort-and-lock",
        name: RouteName.ChannelSortAndLock,
        meta: { requiresAuth: true },
        component: ChannelSortAndLock
      },
      {
        path: "edit-profile",
        name: RouteName.EditProfile,
        meta: { requiresAuth: true },
        component: UserEditForm
      }
    ]
  }
];
